export function isMobileDevice(): boolean {
  let isMobile = false;
  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
      isMobile = true;
    }
  })(navigator.userAgent || navigator.vendor || window['opera']);
  return isMobile;
}

export function isTouchEnabled(): boolean {
  return ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
}

export function isEquivalent(objA: Object, objB: Object, excludeProperty?: string): boolean {
  let aProps = Object.getOwnPropertyNames(objA);
  let bProps = Object.getOwnPropertyNames(objB);
  if (excludeProperty) {
    aProps = aProps.filter(value => value !== excludeProperty);
    bProps = bProps.filter(value => value !== excludeProperty);
  }
  if (aProps.length !== bProps.length) {
    return false;
  }

  for (let i = 0; i < aProps.length; i++) {
    const propName = aProps[i];
    if (objA[propName] !== objB[propName]) {
      return false;
    }
  }
  return true;
};

/**
 * check the element is present in DOM or not.
 * @param element as HTMLElement - element to be checked.
 * @param parentClass as string - parent class name used to loop till parent container for checking hidden elements.
 * @return boolean - return true if element visible in DOM.
 */
export function isVisibleInDOM(element: any, parentClass: string): boolean {
  if (parentClass) {
    while (element && element.offsetParent && element.parentNode && !element.parentNode.classList.contains(parentClass)) {
      element = element.parentNode;
    }
  } else {
    while (element && element.offsetParent && element.parentNode && element.parentNode.tagName !== 'BODY') {
      element = element.parentNode;
    }
  }
  return !!element.offsetParent;
}

/**
 * returns the focusable elements list.
 * @param container as ElementRef
 * @return focusableElements as HTMLElement[]
 */
export function getFocusableElements(container: any): HTMLElement[] {
  const focusableElements = container.nativeElement.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  return focusableElements;
}

/**
* set focus on last focusable element.
* @param focusableElements as HTMLElement[] - all container elements.
* @return element as HTMLElement - set focus and return element.
*/
export function setFocusOnLastFocusableElement(focusableElements: HTMLElement[]): HTMLElement {
  const length = focusableElements.length;
  for (let i = length - 1; i >= 0; i--) {
    const element = focusableElements[i];
    if (element['tabIndex'] !== -1 && !element['disabled']) {
      element.focus();
      return element;
    }
  }
}

/**
 * set focus on first focusable element.
 * @param focusableElements as HTMLElement[] - all container elements.
 * @return element as HTMLElement - set focus and return element.
 */
export function setFocusOnFirstFocusableElement(focusableElements: HTMLElement[]): HTMLElement {
  const length = focusableElements.length;
  for (let i = 0; i < length; i++) {
    const element = focusableElements[i];
    if (element['tabIndex'] !== -1 && !element['disabled']) {
      element.focus();
      return element;
    }
  }
}

/**
 * circulate focus within container.
 * @param event as KeyboardEvent
 * @param focusableElements as HTMLElement[] - all container elements.
 * @param _document as @angular/common/Document - document object
 * @param checkHiddenElements as boolean - true, If want to check and exclude focus for hidden elements.
 * @param parentClass as string - parent class name used to loop till parent container for checking hidden elements.
 */
export function circulateFocus(event: KeyboardEvent, focusableElements: HTMLElement[], _document: any, checkHiddenElements: boolean, parentClass: string) {
  const key = event.key.toLocaleLowerCase();
  if (key === 'tab') {
    event.stopPropagation();
    const length = focusableElements.length;
    if (length) {
      for (let i = 0; i < length; i++) {
        if (focusableElements[i] === _document.activeElement) {
          if (!event.shiftKey) {
            event.preventDefault();
            if (focusableElements[i + 1]) {
              let nextFocusableElementExist = false;
              for (let j = i + 1; j < length; j++) {
                const focusableElement = focusableElements[j];
                let isVisible = true;
                // exclude focus for hidden elements.
                if (checkHiddenElements) {
                  isVisible = isVisibleInDOM(focusableElement, parentClass);
                }
                if (focusableElement['tabIndex'] !== -1 && !focusableElement['disabled'] && isVisible) {
                  focusableElement.focus();
                  nextFocusableElementExist = true;
                  break;
                }
              }
              if (!nextFocusableElementExist) {
                return setFocusOnFirstFocusableElement(focusableElements);
              } else {
                break;
              }
            } else {
              return setFocusOnFirstFocusableElement(focusableElements);
            }
          } else if (event.shiftKey) {
            event.preventDefault();
            if (focusableElements[i - 1]) {
              let previousFocusableElementExist = false;
              for (let j = i - 1; j >= 0; j--) {
                const focusableElement = focusableElements[j];
                let isVisible = true;
                // exclude focus for hidden elements.
                if (checkHiddenElements) {
                  isVisible = isVisibleInDOM(focusableElement, parentClass);
                }
                if (focusableElement['tabIndex'] !== -1 && !focusableElement['disabled'] && isVisible) {
                  focusableElement.focus();
                  previousFocusableElementExist = true;
                  break;
                }
              }
              if (!previousFocusableElementExist) {
                return setFocusOnLastFocusableElement(focusableElements);
              } else {
                break;
              }
            } else {
              return setFocusOnLastFocusableElement(focusableElements);
            }
          }
        }
      }
    }
  }
}

  // export function  ismobileAndTabletcheck(): boolean {
  //   var check = false;
  // tslint:disable-next-line:max-line-length
  //   (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  //   return check;
  // };


/**
 * replacer function for JSON.stringify() to convert the Date object/ function in string.
 * The reason for this replacer is, JSON.stringify() will convert date in string using Date.toISOString(),
 * that makes the date changed to 1 day behind.
 * @param {string} key
 * @param {any} value
 * @return {any}
 */
export function jsonReplacer(data) {
  const replacer = function (key, value) {
    let returnVal = value;
    if (this[key] instanceof Date) {
      returnVal = this[key].toString();
    }
    return this[key] === undefined ? null : returnVal;
  };
  return JSON.stringify(data, replacer, 4); // here JSON.stringify takes function as second argument.
}


/**
 * reviver function for JSON.parse() to convert the string form of Date object/function in its original form.
 * @param {string} key
 * @param {any} value
 * @return {any}
 */
export function jsonReviver(key: string, value: any) {
  let valueAsOriginalForm = value;
  if (typeof this[key] === 'string' && this[key].substring(0, 8) === 'function' && this[key].substring(value.length - 1) === '}') {
    valueAsOriginalForm = eval('(' + this[key] + ')');
  }
  return this[key] === undefined ? null : valueAsOriginalForm;
}
